import React from 'react';
import { Box } from '@kohler-dsm-library/kohler-core';
import { buildDsmImageProps } from '@/aem-dsm-mappers/utils/imageProps';

const CardItem = ({ card = {}, index, selectedIndexes = [], onClick }) => {
  const isActive = Array.isArray(selectedIndexes) && selectedIndexes.includes(index);

  return (
    <Box className={`card-item ${isActive ? 'active' : ''}`} onClick={() => onClick?.(index)}>
      <Box>
        <img
          {...buildDsmImageProps({
            src: card?.cardImage ?? '',
            alt: card?.imageAlt ?? '',
            allowEmptySrc: true,
          })}
        />
      </Box>

      <Box>
        {card?.cardTitle && <h4>{card.cardTitle}</h4>}
        {card?.cardDescription && <p>{card.cardDescription}</p>}
      </Box>
    </Box>
  );
};

export default CardItem;
